import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LanguageProps } from "../types/attribute/language";
import { api } from "../services/api.service";

export const fetchLanguages = createAsyncThunk<LanguageProps[], { query: string }>(
  "fetch/language",
  async ({ query }) => {
    const data = await api.attribute.language.getAll({ name: query });
    return data as LanguageProps[];
  }
);

interface languageState {
  languages: LanguageProps[];
  language: null | LanguageProps;
  loading: boolean;
  error: null | string;
}

const initialState: languageState = {
  languages: [],
  language: null,
  loading: false,
  error: null,
};

export const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    addLanguage: (state, action: PayloadAction<LanguageProps>) => {
      state.languages.push(action.payload);
    },
    removeLanguage: (state, action: PayloadAction<LanguageProps>) => {
      state.languages = state.languages.filter(
        (language) => language.id !== action.payload.id
      );
    },
    updateLanguage: (state, action: PayloadAction<LanguageProps>) => {
      state.languages = state.languages.map((language) =>
        language.id === action.payload.id ? action.payload : language
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchLanguages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLanguages.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.languages = action.payload;
      })
      .addCase(fetchLanguages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export const { addLanguage, updateLanguage, removeLanguage } =
  languageSlice.actions;

export default languageSlice.reducer;
